export default __webpack_public_path__ + "static/media/olivine53.32ceecca.png";